import { Button, Tooltip } from "antd";
import React, { useState } from "react";
import {
    ArrowUpOutlined,
    ArrowDownOutlined,
    SwapOutlined,
} from '@ant-design/icons';

export type Order = 'asc' | 'desc' | 'none';

export const useOrdering = (defaultOrder?: Order) => {
    const [order, setOrder] = useState<Order>(defaultOrder ?? 'none');

    const setChartOrder = () => {
        setOrder(value => value === 'asc' ? 'desc' : value === 'desc' ? 'none' : 'asc');
    }

    return { order, setChartOrder };
}

interface OrderingButtonProps {
    order: Order;
    setChartOrder: () => void;
}

export const OrderingButton: React.FC<OrderingButtonProps> = ({ order, setChartOrder }) => {
    return (
        <Tooltip
            title={
                order === 'asc' ? 'Sort descending' :
                order === 'desc' ? 'Clear sorting' :
                'Sort ascending'
            }
        >
            <Button icon={ order === 'asc' ? <ArrowUpOutlined /> :
                           order === 'desc' ? <ArrowDownOutlined /> :
                           <SwapOutlined rotate={90} />
                        }
                    onClick={setChartOrder}
            />
        </Tooltip>
    )
}